import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonContent, IonItem, IonLabel, IonList, IonModal } from '@ionic/angular';

import { TypeAheadComponent, TypeAheadItemModel } from '@ninety/mobile/platform/components';

@Component({
  selector: 'nty-discussion-seat-select',
  imports: [IonContent, IonItem, IonLabel, IonList, IonModal, TypeAheadComponent],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DiscussionSeatSelectComponent), multi: true },
  ],
  styles: [
    `
      @use 'terra';

      ion-item {
        background: transparent;
        color: terra.color(text);
      }

      ion-item::part(native) {
        --background: transparent;
        --border-color: #{terra.color(border)};
        --border-radius: #{terra.radius(xlarge)};
        --border-style: solid;
        --border-width: 1px;
      }

      .text {
        @include terra.text(body);
        color: terra.color(text);
      }

      .placeholder {
        --color: #{terra.color(text, lightest)};
        color: terra.color(text, lightest);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ion-list>
      <ion-item button detail detail-icon="/assets/icons/caret-down--regular.svg" id="select-discussion-seat">
        <span>
          <ion-label class="terra-body text" [class.placeholder]="isPlaceholder">
            {{ ctrlLabel }}
          </ion-label>
        </span>
      </ion-item>
    </ion-list>

    <ion-modal trigger="select-discussion-seat" #selectSeatModal>
      <ng-template>
        <ion-content>
          <nty-type-ahead
            title="Select Seat"
            [items]="seatOptions"
            [selectedItemId]="selectedSeatHolderId"
            (selectionChange)="onSelectionChange($event); selectSeatModal.dismiss()"
            (selectionCancel)="selectSeatModal.dismiss()" />
        </ion-content>
      </ng-template>
    </ion-modal>
  `,
})
export class DiscussionSeatSelectComponent implements ControlValueAccessor {
  @Input({ required: true }) seatOptions!: TypeAheadItemModel[];

  selectedSeatHolderId = '';
  selectedSeatHolder: TypeAheadItemModel | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeFn!: (val: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  onTouchFn!: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any): void {
    this.onTouchFn = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  setDisabledState(isDisabled: boolean): void {}

  writeValue(seatId: string): void {
    this.setSelectedSeat(seatId);
  }

  onSelectionChange(userId?: string): void {
    this.setSelectedSeat(userId);
    this.onChangeFn?.(userId);
    this.onTouchFn?.();
  }

  get isPlaceholder() {
    return !this.selectedSeatHolder?.name;
  }

  get ctrlLabel() {
    if (this.selectedSeatHolder) {
      return this.selectedSeatHolder?.name ?? '';
    }
    return 'Select Seat';
  }

  private setSelectedSeat(seatId?: string) {
    this.selectedSeatHolder = this.seatOptions.find(u => u._id === seatId) ?? null;
    this.selectedSeatHolderId = seatId ?? '';
  }
}
